module.exports = __webpack_public_path__ + "static/media/RU.ce6b304a.png";